module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/ian_sara_side-465d53e88668c40822120ecc48022186.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/ian_sara_side.png
// module id = 2377
// module chunks = 2